import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';

const ProtectedLoginRoute = ({ children }) => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
  const role = sessionStorage.getItem('role');

  useEffect(() => {
    if (isLoggedIn) {
      setShowLogoutModal(true);
    }
  }, [isLoggedIn]);

  const handleStayLoggedIn = () => {
    setShowLogoutModal(false);
    navigate(`/${role}`);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setShowLogoutModal(false);
  };

  if (!isLoggedIn) {
    return children;
  }

  return (
    <>
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Already Logged In</h3>
            <p className="mb-6">You are currently logged in. Would you like to log out?</p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleStayLoggedIn}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
              >
                Stay Logged In
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-500 text-white hover:bg-red-600 rounded"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProtectedLoginRoute;